module.exports = __webpack_public_path__ + "img/jf-popup-bg.d76b2605.png";